<template>
    <div class="cart__sticky">
        <div class="cart__total">
            <div class="cart__row v-centered">
                <div class="cart__grow">
                    <div class="cart__subtitle">Ваша корзина</div>
                </div>
            </div>

            <div v-if="cart.TOTAL_PRICE_MONTHLY > 0"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div>Разовый платеж</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span data-element="cart_total_price_once"
                              class="cart__val">{{ formatPrice(cart.TOTAL_PRICE_ONCE) }} </span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <div v-if="cart.TOTAL_PRICE_MONTHLY > 0"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div>Ежемесячный платеж</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span data-element="cart_total_price_monthly"
                              class="cart__val cart__val--big">{{ formatPrice(cart.TOTAL_PRICE_MONTHLY) }}</span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <div v-if="cart.TOTAL_PRICE_FULL !== cart.TOTAL_PRICE"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div>Скидка</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span data-element="cart_total_price_discount"
                              class="cart__val cart__val--red">- {{ formatPrice(cart.TOTAL_PRICE_FULL - cart.TOTAL_PRICE) }}</span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <div v-if="cart.TOTAL_PRICE > 0"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div class="cart__name">Общая стоимость</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span data-element="cart_total_price"
                              class="cart__val cart__val--big">{{ formatPrice(cart.TOTAL_PRICE) }}</span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <small class="cart__small">Все цены указаны с учетом НДС.</small>
            <button
                data-element="cart_submit_next"
                type="submit"
                class="button cart__buy"
                :class="{'btn-wait':loader.cart > 0}"
                :disabled="loader.cart > 0"
                @click="$emit('nextButtonHandler')"
            >{{ cart.SUBMIT_BUTTON_TEXT }}
            </button>
        </div>

        <div v-if="userLogin === null"
             class="cart__order">
            <small class="cart__fast">Если у вас нет личного кабинета вы можете оформить быстрый заказ</small>
            <a data-type="link"
               data-element="cart_total_without_registration_link"
               @click="orderWithoutRegisterClickHandler"
               class="button button--outline"
               >Заказать без регистрации</a>
        </div>
    </div>
</template>

<script>
import priceFormatter from '../../../../lib/priceFormatter.js'

export default {
    name: 'CartTotal',
    props: {
        cart: {
            type: Object
        },
        loader: {
            type: Object
        },
        userLogin: {
            type: String
        },
        showQuickBuyLink: {
            type: Boolean
        },
        isOpen: {
            type: Boolean,
            default: true
        },
    },
    data: function () {
        return {};
    },
    methods: {
        formatPrice: function (price) {
            return priceFormatter.format(price)
        },
        orderWithoutRegisterClickHandler: function () {
            let t = this;

            t.$emit('openModal', 'fastOrder')
            t.sendMgoEvent('do-order-without-reg')
        },
        sendMgoEvent: function (eventName) {
            if (typeof window.mgoTriggerEvent !== 'function') {
                return
            }

            window.mgoTriggerEvent(eventName)
        }
    }
}
</script>